import React from 'react';

export function DocumentDownloadIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 7.33398V11.334L7.33333 10.0007" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.99935 11.3333L4.66602 10" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M14.6673 6.66732V10.0007C14.6673 13.334 13.334 14.6673 10.0007 14.6673H6.00065C2.66732 14.6673 1.33398 13.334 1.33398 10.0007V6.00065C1.33398 2.66732 2.66732 1.33398 6.00065 1.33398H9.33398"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6673 6.66732H12.0007C10.0007 6.66732 9.33398 6.00065 9.33398 4.00065V1.33398L14.6673 6.66732Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
